export type CsvValue = string | number | boolean | null | undefined | Date;

const normalizeCsvValue = (value: CsvValue): string => {
  if (value instanceof Date) {
    return value.toISOString();
  }
  if (value == null) {
    return '';
  }
  return String(value);
};

interface BuildCsvOptions {
  includeBom?: boolean;
  quoteAll?: boolean;
  quoteStrings?: boolean;
}

const escapeCsvValue = (
  value: CsvValue,
  options?: BuildCsvOptions
): string => {
  const stringValue = normalizeCsvValue(value);
  const isStringLike = typeof value === 'string' || value instanceof Date;
  const forceQuote = options?.quoteAll || (options?.quoteStrings && isStringLike);
  const needsQuotes = /[",\n\r]/.test(stringValue);

  if (!forceQuote && !needsQuotes) {
    return stringValue;
  }

  const escaped = stringValue.replace(/"/g, '""');
  return `"${escaped}"`;
};

export const buildCsv = (
  headers: CsvValue[],
  rows: CsvValue[][],
  options?: BuildCsvOptions
): string => {
  const headerOptions = options?.quoteAll
    ? options
    : { ...options, quoteStrings: false };
  const lines = [
    headers.map((value) => escapeCsvValue(value, headerOptions)).join(','),
    ...rows.map((row) => row.map((value) => escapeCsvValue(value, options)).join(',')),
  ].join('\n');

  if (options?.includeBom) {
    return `\uFEFF${lines}`;
  }

  return lines;
};
